/* PACKAGES */
import { motion } from "framer-motion";

/* CONTAINER ANIMATION */
const containerAnimation = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 1 },
  },
};

/* DIV ANIMATION */
const animation = {
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      damping: 12,
      delay: 1,
      stiffness: 100,
    },
  },
  hidden: {
    opacity: 0,
    y: 20,
    transition: {
      type: "spring",
      damping: 12,
      delay: 1,
      stiffness: 100,
    },
  },
};

const PrivacyPolicy = () => {
  return (
    <motion.section
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
      className="bg-white py-6 xl:py-14 lg:py-14"
    >
      {/* CONTENT */}
      <motion.div variants={animation} className="p-0">
        <div className="container">
          <h1 className="text-4xl font-fraunces-black tracking-tight">
            Privacy Policy
          </h1>
          <div className="mt-10">
            <p className="text-lg font-source font-normal text-black">
              At Food Farmacy, we are committed to protecting your privacy and
              ensuring the security of your personal information. This Privacy
              Policy outlines how we collect, use, disclose, and safeguard your
              information when you visit our website or make a purchase from us.
              By accessing our website or using our services, you consent to the
              terms of this Privacy Policy.
            </p>

            {/* POINT ONE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Information We Collect
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  <span className="font-source font-bold">
                    Personal Information:
                  </span>{" "}
                  When you make a purchase or create an account on our website,
                  we may collect personal information such as your name, email
                  address, shipping address, billing address, phone number, and
                  payment information.
                </li>
                <li className="text-lg font-source font-normal text-black mt-2">
                  <span className="font-source font-bold">Usage Information:</span>{" "}
                  We may collect non-personal information about your
                  interactions with our website, such as your IP address,
                  browser type, device information, pages visited, and referral
                  URL.
                </li>
                <li className="text-lg font-source font-normal text-black mt-2">
                  <span className="font-source font-bold">Cookies:</span> We use
                  cookies and similar tracking technologies to enhance your
                  browsing experience, analyze trends, administer the website,
                  and gather demographic information. You can control the use of
                  cookies through your browser settings.
                </li>
              </ul>
            </div>

            {/* POINT TWO */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                How We Use Your Information
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  <span className="font-source font-bold">To Process Orders:</span>{" "}
                  We use your personal information to process and fulfill your
                  orders, communicate with you about your purchases, and provide
                  customer support.
                </li>
                <li className="text-lg font-source font-normal text-black mt-2">
                  <span className="font-source font-bold">
                    To Improve Our Services:
                  </span>{" "}
                  We may use your information to analyze trends, track user
                  interactions, and improve the functionality and usability of
                  our website.
                </li>
                <li className="text-lg font-source font-normal text-black mt-2">
                  <span className="font-source font-bold">
                    To Send Promotional Emails:
                  </span>{" "}
                  With your consent, we may send you promotional emails about
                  new products, special offers, and other updates. You can
                  opt-out of receiving these emails at any time.
                </li>
                <li className="text-lg font-source font-normal text-black mt-2">
                  <span className="font-source font-bold">
                    To Protect Our Rights:
                  </span>{" "}
                  We may use your information to investigate and prevent
                  fraudulent activities, unauthorized access, and other illegal
                  activities.
                </li>
              </ul>
            </div>

            {/* POINT THREE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Information Sharing and Disclosure
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  We do not sell, trade, or rent your personal information to
                  third parties without your consent.
                </li>
                <li className="text-lg font-source font-normal text-black mt-2">
                  We may share your information with trusted third-party service
                  providers who assist us in operating our website, conducting
                  business, or servicing you, as long as they agree to keep your
                  information confidential.
                </li>
                <li className="text-lg font-source font-normal text-black mt-2">
                  We may disclose your information to comply with legal
                  obligations, enforce our policies, or protect our rights,
                  property, or safety.
                </li>
              </ul>
            </div>

            {/* POINT FOUR */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Data Security
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  We implement appropriate security measures to protect your
                  personal information from unauthorized access, disclosure,
                  alteration, or destruction.
                </li>
                <li className="text-lg font-source font-normal text-black mt-2">
                  Despite our best efforts, no method of transmission over the
                  internet or electronic storage is 100% secure. Therefore, we
                  cannot guarantee absolute security of your information.
                </li>
              </ul>
            </div>

            {/* POINT FIVE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Third-Party Links
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  Our website may contain links to third-party websites that are
                  not operated by us. We are not responsible for the privacy
                  practices or content of these third-party sites.
                </li>
              </ul>
            </div>

            {/* POINT SIX */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Children's Privacy
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  Our website is not intended for children under the age of 13.
                  We do not knowingly collect personal information from children
                  under 13. If you believe we have inadvertently collected
                  information from a child under 13, please contact us
                  immediately, and we will take steps to remove the information.
                </li>
              </ul>
            </div>

            {/* POINT SEVEN */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Changes to This Privacy Policy
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  We reserve the right to update or modify this Privacy Policy
                  at any time without prior notice. Any changes will be
                  effective immediately upon posting on our website.
                </li>
              </ul>
            </div>

            {/* POINT EIGHT */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Contact Us
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  If you have any questions or concerns about our Privacy Policy
                  or the handling of your personal information, please contact
                  us.
                </li>
              </ul>
            </div>

            <div className="mt-10">
              <p className="text-lg font-source font-normal text-black">
                By using our website and services, you acknowledge that you have
                read and understood this Privacy Policy. Thank you for trusting
                Food Farmacy with your personal information.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.section>
  );
};

export default PrivacyPolicy;
